var cov_hxo05y3r8 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Tree/Checkbox.tsx",
      hash = "d95d2766fc9f84498973015fd6c97993e8919717",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Tree/Checkbox.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 52
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 59
        }
      },
      "3": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 29
        }
      },
      "4": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 69
        }
      },
      "5": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 32
        }
      },
      "6": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 42
        }
      },
      "7": {
        start: {
          line: 32,
          column: 36
        },
        end: {
          line: 32,
          column: 46
        }
      },
      "8": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 29
        }
      },
      "9": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 29
        }
      },
      "10": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 31
        }
      },
      "11": {
        start: {
          line: 39,
          column: 36
        },
        end: {
          line: 39,
          column: 46
        }
      },
      "12": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 34
        }
      },
      "13": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 43
        }
      },
      "14": {
        start: {
          line: 45,
          column: 26
        },
        end: {
          line: 45,
          column: 36
        }
      },
      "15": {
        start: {
          line: 46,
          column: 20
        },
        end: {
          line: 46,
          column: 40
        }
      },
      "16": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 53
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 29,
            column: 3
          }
        },
        line: 26
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        loc: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 48
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 38
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 11
          },
          end: {
            line: 56,
            column: 3
          }
        },
        line: 44
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 29
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 29
          }
        }],
        line: 33
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 40,
            column: 33
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 40,
            column: 28
          },
          end: {
            line: 40,
            column: 29
          }
        }, {
          start: {
            line: 40,
            column: 32
          },
          end: {
            line: 40,
            column: 33
          }
        }],
        line: 40
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Tree/Checkbox.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import Checkbox from '../Checkbox/Checkbox';
import { treeClass } from './styles';
import { getDirectionClass } from '../utils/classname';

var TreeCheckbox =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TreeCheckbox, _PureComponent);

  var _super = _createSuper2(TreeCheckbox);

  function TreeCheckbox(props) {
    var _this;

    _classCallCheck(this, TreeCheckbox);

    cov_hxo05y3r8.f[0]++;
    cov_hxo05y3r8.s[0]++;
    _this = _super.call(this, props);
    cov_hxo05y3r8.s[1]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_hxo05y3r8.s[2]++;
    props.datum.bind(props.id, _this.forceUpdate.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(TreeCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_hxo05y3r8.f[1]++;
      cov_hxo05y3r8.s[3]++;

      _get(_getPrototypeOf(TreeCheckbox.prototype), "componentDidMount", this).call(this); // When dragging a node,
      // it will first trigger the constructor of the new node,
      // then trigger the willUnmount of the old node,
      // and finally trigger the didMount of the new node,
      // the old node will unload the update event, so bind it here again


      cov_hxo05y3r8.s[4]++;
      this.props.datum.bind(this.props.id, this.forceUpdate.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_hxo05y3r8.f[2]++;
      cov_hxo05y3r8.s[5]++;

      _get(_getPrototypeOf(TreeCheckbox.prototype), "componentWillUnmount", this).call(this);

      cov_hxo05y3r8.s[6]++;
      this.props.datum.unbind(this.props.id);
    }
  }, {
    key: "checkDisabled",
    value: function checkDisabled() {
      cov_hxo05y3r8.f[3]++;

      var _ref = (cov_hxo05y3r8.s[7]++, this.props),
          datum = _ref.datum,
          id = _ref.id,
          disabled = _ref.disabled;

      cov_hxo05y3r8.s[8]++;

      if (disabled) {
        cov_hxo05y3r8.b[0][0]++;
        cov_hxo05y3r8.s[9]++;
        return true;
      } else {
        cov_hxo05y3r8.b[0][1]++;
      }

      cov_hxo05y3r8.s[10]++;
      return datum.isDisabled(id);
    }
  }, {
    key: "handleChange",
    value: function handleChange(_, checked) {
      cov_hxo05y3r8.f[4]++;

      var _ref2 = (cov_hxo05y3r8.s[11]++, this.props),
          datum = _ref2.datum,
          id = _ref2.id,
          onChange = _ref2.onChange;

      cov_hxo05y3r8.s[12]++;
      datum.set(id, checked ? (cov_hxo05y3r8.b[1][0]++, 1) : (cov_hxo05y3r8.b[1][1]++, 0));
      cov_hxo05y3r8.s[13]++;
      onChange(datum.getValue(), id);
    }
  }, {
    key: "render",
    value: function render() {
      cov_hxo05y3r8.f[5]++;

      var _ref3 = (cov_hxo05y3r8.s[14]++, this.props),
          datum = _ref3.datum,
          id = _ref3.id;

      var checked = (cov_hxo05y3r8.s[15]++, datum.getChecked(id));
      cov_hxo05y3r8.s[16]++;
      return (
        /*#__PURE__*/
        React.createElement(Checkbox, {
          checked: checked,
          disabled: this.checkDisabled(),
          onChange: this.handleChange,
          className: treeClass(getDirectionClass('checkbox')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 7
          }
        })
      );
    }
  }]);

  return TreeCheckbox;
}(PureComponent);

export { TreeCheckbox as default };